export var DidNotGetInsiderFreeDutiesIA = function DidNotGetInsiderFreeDutiesIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return WHY_I_DID_NOT_RECEIVE_FREE_DUTIES(strictLocalize);
    },
    getDescription: function getDescription() {
      return [INSIDER_OFFERS_FREE_DUTIES_WITH_SELECT_BRANDS(strictLocalize)];
    }
  };
};
var WHY_I_DID_NOT_RECEIVE_FREE_DUTIES = function WHY_I_DID_NOT_RECEIVE_FREE_DUTIES(strictLocalize) {
  return strictLocalize({
    id: "/eaC3R",
    defaultMessage: [{
      "type": 0,
      "value": "Waarom heb ik geen gratis invoerrechten op mijn bestelling gekregen?"
    }]
  });
};
var INSIDER_OFFERS_FREE_DUTIES_WITH_SELECT_BRANDS = function INSIDER_OFFERS_FREE_DUTIES_WITH_SELECT_BRANDS(strictLocalize) {
  return strictLocalize({
    id: "Kl7yLn",
    defaultMessage: [{
      "type": 0,
      "value": "Het is belangrijk op te merken dat je Insider-lidmaatschap gratis invoerrechten biedt bij bepaalde merken. Hoewel dit voordeel niet van toepassing is op de hele marktplaats, kun je tijdens het rondkijken op Faire makkelijk zien welke merken in aanmerking komen. Zoek naar merken die zijn gemarkeerd met ‘Gratis verzending en gratis invoerrechten met Insider’, samen met een blauw sleutelsymbool. Als je Insider-lidmaatschap de invoerrechten voor een bepaald merk dekt, wordt dit bovendien aangegeven bij het afrekenen."
    }]
  });
};